// extracted by mini-css-extract-plugin
export var productImage = "_rp-1";
export var viewLink = "_rp-2";
export var wishlistItem = "_rp-0";